import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from 'shared/components/Link/Link';
import s from './LinkList.css';

class LinkList extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape()),
    buildLink: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    handleClickShowAll: PropTypes.func,
    isMobile: PropTypes.bool,
    showAllTitle: PropTypes.string,
    showAll: PropTypes.bool,
    lensEvent: PropTypes.string,
    currentSlug: PropTypes.string,
  };
  static defaultProps = {
    list: null,
    onClick: undefined,
    isMobile: false,
    showAll: false,
    showAllTitle: '',
    lensEvent: '',
    currentSlug: '',
    handleClickShowAll: () => {},
  };

  state = {
    collapsed: true,
  };

  toggleCollapse = () => {
    this.setState(({ collapsed }) => ({ collapsed: !collapsed }));
  };

  handleLinkClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  renderLink = (item, lensEvent) => {
    if (item.slug) {
      return (
        <Link
          key={item.title}
          onClick={this.handleLinkClick}
          to={`/${this.props.buildLink(item.slug)}/`.replace(/\/\//g, '/')}
          className={cx(s.linkItem, { [s.linkItemCurrent]: this.props.currentSlug === item.slug })}
          data-lens-event={lensEvent}
        >
          {item.locale_title || item.title}
        </Link>
      );
    }
    return (
      <span key={item.title} className={s.textItem}>
        {item.locale_title || item.title}
      </span>
    );
  };

  render() {
    const {
      list,
      title,
      isMobile,
      showAllTitle,
      showAll,
      handleClickShowAll,
      lensEvent,
    } = this.props;
    const { collapsed } = this.state;

    return list && list.length > 0
      ? <div className={cx(s.root, { [s.mobile]: isMobile })}>
          <div onClick={this.toggleCollapse} className={cx(s.title, { [s.active]: collapsed })}>
            {title}
            <i className={`fa fa-angle-down ${s.titleIcon}`} />
          </div>
          <div style={{ display: collapsed ? 'flex' : 'none' }} className={s.list}>
            {list.map(item => this.renderLink(item, lensEvent))}
            {showAll &&
              <div onClick={handleClickShowAll} className={s.showAllButton}>
                <FormattedMessage id={showAllTitle} />
              </div>}
          </div>
        </div>
      : null;
  }
}

export default withStyles(s)(LinkList);



// WEBPACK FOOTER //
// ./src/shared/components/LinkList/LinkList.js